module.exports = __webpack_public_path__ + "media/images/athletes/3430-d2c0ba78ab2bd151b61282ca929b9bee.png";